<template>
  <div class="farms">
    <div class="heading">
      <h1>{{$ml.get(`Farms`)}}</h1>
      <div class="buttons">
        <router-link :to="'/dashboard/farms/map-view'">{{$ml.get(`Map View`)}}</router-link>
        <router-link :to="'/dashboard/farms/list-view'">{{$ml.get(`List View`)}}</router-link>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.farms {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .heading {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .buttons {
      border-radius: 10px;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      a {
        color: rgb(128, 136, 153);
        background-color: #E0E0E0;
        font-size: 14px;
        padding:8px 32px;
        font-weight: 500;
        text-transform: uppercase;
        &.router-link-active, &:hover {
          color: #fff;
          background-color: $mainGreen;
        }
      }
    }
  }
  @media(max-width:768px) {
    .heading {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 12px;
      h1 {
        margin-top: 0;
        margin-bottom: 12px;
      }
      .buttons {
        width: 100%;
        a {
          width: 50%;
          text-align: center;
        }
      }
    }
  }
}
</style>
